/**
 * The hover state a calendar chip needs to expand from its compact row to the
 * full one on a dense Month day. Shared by `WorkshopsCalendarChip` and
 * `InertWorkshopChip` so the expand behaviour can't drift between the two.
 */
import { useState } from 'react';

export interface WorkshopChipHover {
  hovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export function useWorkshopChipHover(): WorkshopChipHover {
  const [hovered, setHovered] = useState(false);
  return {
    hovered,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
  };
}
